<template>
    <div>
        <div v-for="(vd, key) in video" :key="key">
            <video 
                class="app-video"
                :src="$pathFilesSystem+'/'+vd.url"
                controls
                autoplay
                loop
                muted
            ></video>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppVideo',
    props: {
        video: {
            required: true
        }
    }
}
</script>

<style scoped>
.app-video {
    width: 100%;
}
</style>